import { displayedPercent } from '../home/platform';

// Les formats des quantités d'un environnement (CPU, mémoire, disque, part),
// en français. Tirés de `odooProjectForm/capacityProfiles.ts` à l'étape 9c du
// plan « plateforme d'applications » : l'onglet « Configuration » (le cœur)
// les lit aussi.

const NBSP = '\u00a0';

function frenchNumber(value: number, digits: number): string {
  return new Intl.NumberFormat('fr-FR', {
    maximumFractionDigits: digits,
  }).format(value);
}

/** Millicores as CPUs: 200 → « 0,2 CPU ». */
export function formatCpu(millicores: number): string {
  return `${frenchNumber(millicores / 1000, 2)}${NBSP}CPU`;
}

/** Mi as Mio below 1 Gio, Gio above: 768 → « 768 Mio », 2560 → « 2,5 Gio ». */
export function formatMemory(mebibytes: number): string {
  if (mebibytes < 1024) {
    return `${frenchNumber(mebibytes, 0)}${NBSP}Mio`;
  }
  return `${frenchNumber(mebibytes / 1024, 1)}${NBSP}Gio`;
}

export function formatDisk(gigabytes: number): string {
  return `${frenchNumber(gigabytes, 0)}${NBSP}Go`;
}

/**
 * The share of `total` that `part` is, as a rounded percentage — Intl's
 * rounding (`displayedPercent`), the one the bars' colours are read from,
 * so that a `Meter` given this text (ProjectPanel.tsx) is coloured as its
 * figure reads.
 */
export function formatShare(part: number, total: number): string {
  return `${displayedPercent(part / total)}${NBSP}%`;
}
